module.exports = __webpack_public_path__ + "img/2_2.58bfc075.jpg";